import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Timepicker} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Timepicker, {
            'range': true,
            'clearable': true,
            'ev-$model:value': function($v) {
                $this.set('time', $v);
            },
            'value': $this.get('time')
        }),
        _$ct('\n    You selected: '),
        JSON.stringify(this.get('time')),
        _$ce(2, 'br'),
        _$ce(2, 'br'),
        _$cc(Timepicker, {
            'range': true,
            'clearable': true,
            'multiple': true,
            'ev-$model:value': function($v) {
                $this.set('timeArr', $v);
            },
            'value': $this.get('timeArr')
        }),
        _$ct('\n    You selected: '),
        JSON.stringify(this.get('timeArr'))
    ], 0 /* UnknownChildren */);
};